import {IdashboardFilters} from "./Dashboard.type";

export const initialStateFilters: IdashboardFilters = {
  battery_russia: {
    value: 0,
    turnOn: false,
  },
  critical: {
    value: false,
    turnOn: false,
  },
  national: {
    value: false,
    turnOn: false,
  },
  growth_potential: {
    value: false,
    turnOn: false,
  },
  gpb: {
    value: false,
    turnOn: false,
  },
  invest_volume_tier: {
    value: 0,
    turnOn: false,
  },
  market_volume_tier: {
    value: 0,
    turnOn: false,
  },
};
